import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import TickerBar from "./TickerBar";
import ContactModal from "../ContactModal";
import { onOpenContactModal } from "../../lib/contactBus";

export default function Layout() {
  const [contactOpen, setContactOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => onOpenContactModal(() => setContactOpen(true)), []);
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--slate-900)] font-sans-base">
      <TickerBar />
      <Header />
      <main key={loc.pathname} className="page-fade">
        <Outlet />
      </main>
      <Footer />
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  );
}
